import { createElement } from "@max/max";
import { getImageUrl } from '../../lib/utils/imageUtils';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import './index.scss';
const Transit = (props) => {
    const week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    const formatterDay = (date, t) => {
        const y = date.substr(0, 4);
        const m = date.substr(5, 2);
        const d = date.substr(8, 2);
        if (t === 'time') {
            return new Date(Number(y), Number(m) - 1, Number(d)).getTime() / 1000; // 精确到秒
        }
        return m + '月' + d + '日  ' + week[new Date(Number(y), Number(m) - 1, Number(d)).getDay()];
    };
    return <View className='ft-flight-transit-container' style={{
        backgroundColor: props.titleConfig.background || 'transparent',
        padding: '18rpx'
    }}>
      <View className='ft-title'>
        <View className='ft-title-left' style={{
        backgroundColor: props.titleConfig.titleLeft
    }}></View>
        <Text className='ft-title-label' style={{
        color: props.titleConfig.titleColor
    }}>{props.titleConfig.title}</Text>
      </View>
      <View className='ft-list'>
        {props.list.map((item, idx) => {
        return <View className='ft-list-item' key={`transit-item-${idx}`}>
                <Image className='ft-img' source={{
            uri: getImageUrl(item.cityPicture, 348, 0)
        }}/>
                <View className='ft-content'>
                  <View className='ft-content-city'>
                    <Text className='ft-content-city-item'>{item.departCityName}</Text>
                    <View className='ft-transit-city'>
                      <View className='ft-round-info'>
                        <Image className='ft-transit-icon' source={{
            uri: 'https://p1.meituan.net/travelcube/5e5690bcebaddee09cbac695ad8edb26198.png'
        }}/>
                        <Text className='ft-transit-name'>中转</Text>
                        <Image className='ft-transit-icon' source={{
            uri: 'https://p0.meituan.net/travelcube/4ba973a0ae23fa4de52fe5172e998198310.png'
        }}/>
                      </View>
                      <Text className='ft-transit-label'>{item.transitCityName}</Text>
                    </View>
                    <Text className='ft-content-city-item'>{item.arriveCityName}</Text>
                  </View>
                  <Text className='ft-content-date'>{formatterDay(item.flightDate)}</Text>
                  <View className='ft-content-price'>
                    <Text className='ft-price-symbol'>￥</Text>
                    <Text className='ft-price-large'>{item.price}</Text>
                  </View>
                </View>
                <Text className='ft-bottom-btn' onClick={() => props.jump(item)}>立即抢购</Text>
              </View>;
    })}
      </View>
    </View>;
};
export default Transit;
